export default{
    adminUrl : "http://" + window.location.hostname + ":8080"
}